import PropTypes from 'prop-types';

const VerificationShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  post: PropTypes.object,
  quantity: PropTypes.number,
  unit: PropTypes.oneOf(['WEEK', 'MONTH']),
});

export default VerificationShape;
